<template>
    <!-- theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <ContactServicePopupOne v-modal="show" :data-set="dataSet" @close="close" @open="open"/>
    </div>

     <!-- theme two -->
    <div v-if="themeStore.themeIndex === 2">
        <ContactServicePopupTwo v-modal="show" :data-set="dataSet" @close="close" @open="open"/>
    </div>
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>

<script setup lang="ts">
import { getCustomerServiceList } from '@/api/home'
import StatusPopup from '@/components/common/statusPopup.vue'
import ContactServicePopupOne from '@/themes/themeOne/profile/contactServicePopup.vue'
import ContactServicePopupTwo from '@/themes/themeTwo/profile/contactServicePopup.vue'
import { ref, defineExpose, computed } from 'vue'
import { ContactItem, ContactServiceData } from './supportScript'
import { useThemeStore } from '@/stores/theme'

const themeStore = useThemeStore()
const show = ref(false)
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const serviceList = ref<ContactItem[]>([])

const dataSet = computed<ContactServiceData>(() => ({
    serviceList: serviceList.value,
    show: show.value
}))

const open = () => {
    getServiceList()
}

const close = () => {
    show.value = false
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}

const getServiceList = () => {
    getCustomerServiceList().then(res => {
        serviceList.value = res.data
        show.value = true
    }).catch(err => {
        if (err.code != 401) {
            showError(err)
        }

    })
}

defineExpose({
    open,
    close
})

</script>